import React from "react"
import { Link } from "gatsby"
import SEO from "../components/utilities/seo"

export default (props) => (
  < >
    <SEO title="Page two" />
    <h1>reunion</h1>
  </>
)